import { AsyncModule } from 'vuex-async-mutations';

import { ModuleStatusContext } from '@/types';
import meter from './meter';
import installation from './installation';

import { InstallationModule } from '@/types';
export interface InstallationModuleStatus {
  context: ModuleStatusContext;
  pollTimeoutId?: number;
  status: 'processing' | 'error' | 'success' | 'failure';
  error?: string;
  [key: string]: any;
}

export interface InstallationItemState {
  isEnded?: boolean;
  lastError?: string;
  modules: Record<string, InstallationModule>;
  status: Record<string, InstallationModuleStatus>;
}

export interface InstallationState {
  installations: Record<number, InstallationItemState>;
}

const stateFactory = (): InstallationState => ({
  installations: {},
});

export const module = {
  namespaced: true,

  async: true,

  state: stateFactory,

  getters: {
    ...installation.getters,
    ...meter.getters,
  },

  mutationsAsync: {
    ...installation.mutationsAsync,
    ...meter.mutationsAsync,
  },

  mutations: {
    ...installation.mutations,
    ...meter.mutations,
  },

  actionsAsync: {
    ...installation.actionsAsync,
    ...meter.actionsAsync,
  },

  actions: {
    ...installation.actions,
    ...meter.actions,
  },
} as AsyncModule<InstallationState, any>;

export default module;
